module.exports = __webpack_public_path__ + "c50eee324fef03ec2258c35b6be23742.png";